define('ROOM4.CCAGalleryShowcase.CCAGalleryShowcase', [
    'ROOM4.CCAGalleryShowcase.Showcase.View'
], function(
    ShowcaseView
) {
    'use strict';

    function getConfigValue(container, key, fallback) {
        var Environment = container.getComponent('Environment');
        var value = Environment && Environment.getConfig(key);

        return value === undefined || value === null ? fallback : value;
    }

    function getPositiveInteger(value, fallback) {
        var parsed = parseInt(value, 10);

        return parsed > 0 ? parsed : fallback;
    }

    return {
        mountToApp: function mountToApp(container) {
            var PDP = container.getComponent('PDP');
            var enabled = getConfigValue(container, 'CCAGalleryShowcase.enabled', false);

            if (!PDP || enabled !== true) {
                return;
            }

            PDP.addChildViews(PDP.PDP_FULL_VIEW, {
                'CCAGalleryShowcase.Items': {
                    'GalleryShowcase.View': {
                        childViewIndex: 1,
                        childViewConstructor: function childViewConstructor() {
                            var itemInfo = PDP.getItemInfo();
                            var itemId = itemInfo && itemInfo.item && itemInfo.item.internalid;

                            return new ShowcaseView({
                                application: container,
                                container: container,
                                itemId: itemId,
                                limit: getPositiveInteger(
                                    getConfigValue(container, 'CCAGalleryShowcase.maxItems', 6),
                                    6
                                ),
                                title: getConfigValue(
                                    container,
                                    'CCAGalleryShowcase.title',
                                    'See It On Real Vehicles'
                                )
                            });
                        }
                    }
                }
            });
        }
    };
});
